import {
  FormControlLabel as MUIFormControlLabel,
  FormControlLabelProps,
  styled,
} from '@mui/material'
import { useRadioGroup } from '@mui/material/RadioGroup'
import { lighten } from '@mui/system/colorManipulator'
import clsx from 'clsx'

const StyledFormControlLabel = styled(MUIFormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'checked',
})(({ theme, checked }) => ({
  ...(checked! && {
    backgroundColor: lighten(theme.palette.primary.main, 0.87),
    borderColor: lighten(theme.palette.primary.main, 0.15),
  }),
  '&:focus-within': {
    outline: `2px solid ${theme.palette.primary.dark}`,
    outlineOffset: '2px',
  },
}))

export default function FormControlLabel(props: FormControlLabelProps): JSX.Element {
  const radioGroup = useRadioGroup()
  const isChecked = radioGroup !== undefined ? radioGroup.value === props.value : Boolean(props.checked)

  return (
    <StyledFormControlLabel
      className={clsx('control-label', { 'control-label--checked': isChecked })}
      checked={isChecked}
      {...props}
    />
  )
}
